import { cn } from '@/lib/utils'

/** Shared home control for marketing / guest brand marks (`Link to="/"`). */
export const MARKETING_HOME_LINK_CLASS = cn(
  'inline-flex min-h-11 touch-manipulation select-none items-center rounded-[var(--radius-button)] outline-none ring-offset-background',
  'transition-[opacity,transform] duration-150 ease-[cubic-bezier(0.2,0,0,1)] hover:opacity-90 active:scale-[0.96]',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
)
